const ProjectDetailsTabPath = {
  Overview: "overview",
  ProjectConfiguration: "setup",
  Participants: "participants",
  Interviews: "interviews",
  Insights: "insights"
};
const allProjectDetailsTabPaths = [
  ProjectDetailsTabPath.Overview,
  ProjectDetailsTabPath.ProjectConfiguration,
  ProjectDetailsTabPath.Participants,
  ProjectDetailsTabPath.Interviews,
  ProjectDetailsTabPath.Insights
];
function buildProjectUrlPath(projectId, tabPath = ProjectDetailsTabPath.ProjectConfiguration, interviewId, transcriptFragmentId) {
  const base = `/project/${encodeURIComponent(projectId)}/${tabPath}`;
  const url = interviewId ? `${base}/${encodeURIComponent(interviewId)}` : base;
  const params = new URLSearchParams();
  if (transcriptFragmentId) params.append("f", transcriptFragmentId);
  const queryString = params.toString();
  return queryString ? `${url}?${queryString}` : url;
}
export {
  ProjectDetailsTabPath,
  buildProjectUrlPath
};
//# sourceMappingURL=adminAppRoutes.js.map
